// ═══════════════════════════════════════════════════════════════
//  BandeauHorsLigne — « pas de connexion » (lot T8)
//
//  Le service worker permet à l'app de S'OUVRIR sans réseau ; il ne rend rien
//  fonctionnel pour autant. La persistance hors ligne de Firestore est
//  volontairement désactivée, donc hors réseau : aucune donnée n'est lue,
//  aucune écriture ne part. Ce bandeau le dit, sans quoi l'utilisateur croit
//  à un bug.
//
//  Monté dans App(), au-dessus de Router() : Router a quatre branches de
//  retour (login, spinner, mot de passe forcé, Layout) et le bandeau doit
//  être visible sur les quatre.
// ═══════════════════════════════════════════════════════════════
import { useState, useEffect } from "react";

import { EPJ } from "../theme";

export function useEnLigne() {
  const [enLigne, setEnLigne] = useState(
    () => typeof navigator === "undefined" || navigator.onLine !== false,
  );
  useEffect(() => {
    const on = () => setEnLigne(true);
    const off = () => setEnLigne(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return enLigne;
}

export function BandeauHorsLigne() {
  const enLigne = useEnLigne();
  if (enLigne) return null;
  return (
    <div role="status" aria-live="polite" style={{
      position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 9999,
      background: EPJ.orange, color: EPJ.white,
      fontSize: 13, fontWeight: 600, lineHeight: 1.35, textAlign: "center",
      padding: "10px 16px",
      paddingBottom: "max(10px, env(safe-area-inset-bottom))",
      boxShadow: "0 -2px 12px rgba(0,0,0,.18)",
    }}>
      Pas de connexion — aucune donnée n'est chargée ni enregistrée.
    </div>
  );
}
